/*----------------------------------------
Locale Root
----------------------------------------*/
function getLocaleRoot() {

  const path = window.location.pathname;

  if (path.startsWith('/en')) return '/en/';
  if (path.startsWith('/th')) return '/th/';
  if (path.startsWith('/zh')) return '/zh/';
  if (path.startsWith('/fr')) return '/fr/';
  if (path.startsWith('/es')) return '/es/';

  return '/';

}

/*----------------------------------------
Hide Checkout Elements
----------------------------------------*/
function hideMixedCartElements() {

  document.querySelectorAll(`
    .cart--button-checkout,
    [name="checkout"],
    .shopify-payment-button,
    .dynamic-checkout__content,
    #zigzag-worldshopping-checkout,
    [id^="zigzag-worldshopping"]
  `).forEach(el => {

    el.style.display = 'none';
    el.style.pointerEvents = 'none';
    el.style.opacity = '0';

  });

}

/*----------------------------------------
Init
----------------------------------------*/
document.addEventListener('DOMContentLoaded', async () => {

  const DIGITAL_IDS =
    (window.DIGITAL_VARIANT_IDS || []).map(Number);

  const localeRoot = getLocaleRoot();

  try {

    // const res = await fetch(`${localeRoot}cart.js`, {
    //   credentials: 'same-origin'
    // });
    // const cart = await res.json();
    const cart = await requestJSON(`${window.Shopify.routes.root}cart.js`);

    const hasDigital = cart.items.some(item =>
      DIGITAL_IDS.includes(Number(item.variant_id))
    );

    const hasPhysical = cart.items.some(item =>
      !DIGITAL_IDS.includes(Number(item.variant_id))
    );

    const isMixed = hasDigital && hasPhysical;

    if (!isMixed) return;

    console.log('[Mixed Cart Detected]');

    /*----------------------------------------
    Inject CSS
    ----------------------------------------*/
    if (!document.querySelector('#mixed-cart-style')) {

      const style = document.createElement('style');

      style.id = 'mixed-cart-style';

      style.innerHTML = `
        .cart--button-checkout,
        [name="checkout"],
        .shopify-payment-button,
        .dynamic-checkout__content,
        #zigzag-worldshopping-checkout,
        [id^="zigzag-worldshopping"] {
          display: none !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `;

      document.head.appendChild(style);

    }

    /*----------------------------------------
    Hide Existing Elements
    ----------------------------------------*/
    hideMixedCartElements();

    /*----------------------------------------
    Observe Future Inject
    ----------------------------------------*/
    const observer = new MutationObserver(() => {
      hideMixedCartElements();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    /*----------------------------------------
    Alert UI
    ----------------------------------------*/
    const checkoutWrapper =
      document.querySelector('.cart__checkout-wrapper');

    if (checkoutWrapper) {
      checkoutWrapper.classList.add('is-cart-blocked');
    }

    const alertMsg =
      document.querySelector('.cart-mixed-alert');

    if (alertMsg) {
      alertMsg.hidden = false;
    }

  } catch (e) {

    console.error('[Cart Validation] fetch error', e);

  }

});